<button (click)="onClick($event)" [disabled]="disabled" [type]="type">
  <ng-content></ng-content>
</button>
